export enum SwitchElement {
  PERFORMANCE = 'Performance',
  ASSET_ALLOCATION = 'Asset allocation',
  ADDITIONAL_INFO = 'Additional info',
  FAQ = 'FAQs',
}
